import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_BASE_URL || "https://api.varaii.com";

const api = axios.create({
  baseURL: `${BASE_URL}/api/v1`,
  withCredentials: true,   // desktop / same-site cookie
});

/* Send the token as Authorization: Bearer so auth works even where the browser
   blocks the cross-site cookie (iPhone Safari etc.). Stored at login. */
export const setSellerToken = (t) => {
  try { t ? localStorage.setItem("sellerToken", t) : localStorage.removeItem("sellerToken"); } catch {}
};
export const getSellerToken = () => {
  try { return localStorage.getItem("sellerToken"); } catch { return null; }
};

api.interceptors.request.use(cfg => {
  const t = getSellerToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

api.interceptors.response.use(
  r => r,
  err => {
    if (err?.response?.status === 401 && window.location.pathname !== "/login") {
      setSellerToken(null);   // stale token → clear it
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export default api;
